<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="proformaIncomes" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="proformaIncomeId" selectionMode="single"
  [(selection)]="proformaIncome" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      @if (!proformaId) {
        <h1 style="float: left;margin: 6px;">Proforma Incomes</h1>
      }
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!isPublicAndPublish) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">Income +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'seasonName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'seasonStart', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'seasonEnd', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'numNights', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'hightRateAmt', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'highAdjPct', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'targetRateAmt', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'targetOccupancyPct', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lowRateAmt', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lowAdjPct', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-proformaIncome>
    @if (proformaId && (proformaId == proformaIncome.proformaId)) {
      <tr [pSelectableRow]="proformaIncome">
        <td>{{proformaIncome.seasonName}}</td>
        <td>{{proformaIncome.seasonStart | date:'MM-dd-yyyy'}}</td>
        <td>{{proformaIncome.seasonEnd | date:'MM-dd-yyyy'}}</td>
        <td>{{proformaIncome.numNights}}</td>
        <td>{{proformaIncome.hightRateAmt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
        <td>{{proformaIncome.highAdjPct | percent}}</td>
        <td style="background-color: #FFBF00 !important;">{{proformaIncome.targetRateAmt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
        <td style="background-color: #FFBF00 !important;">{{proformaIncome.targetOccupancyPct | percent}}</td>
        <td>{{proformaIncome.lowRateAmt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
        <td>{{proformaIncome.lowAdjPct | percent}}</td>
        <!-- <td>{{getStatusName(proformaIncome)}}</td> -->
        @if (!isPublicAndPublish) {
          <td><span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(proformaIncome)"></i>
            </a>
          </span>
        </td>
      }
    </tr>
  }
  @if (!proformaId) {
    <tr [pSelectableRow]="proformaIncome">
      <td>{{proformaIncome.seasonName}}</td>
      <td>{{proformaIncome.seasonStart | date:'MM-dd-yyyy'}}</td>
      <td>{{proformaIncome.seasonEnd | date:'MM-dd-yyyy'}}</td>
      <td style="background-color: #FFBF00 !important;">{{proformaIncome.targetRateAmt | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
      <td style="background-color: #FFBF00 !important;">{{proformaIncome.targetOccupancyPct | percent}}</td>
      <!-- <td>{{getStatusName(proformaIncome)}}</td> -->
      @if (!isPublicAndPublish) {
        <td><span style="float:none">
          <a>
            <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(proformaIncome)"></i>
          </a>
        </span>
      </td>
    }
  </tr>
}
</ng-template>
</p-table>